module.exports = __webpack_public_path__ + "static/media/advasonic-toothbrush-head-3.b80f2362.jpg";